<template>
  <div class="pagination" v-if="totalPages > 1">
    <button
      class="pagination__btn"
      :disabled="page === 1"
      @click="$emit('change', page - 1)"
    >
      ‹
    </button>

    <button
      v-for="p in visiblePages"
      :key="p"
      class="pagination__page"
      :class="{ 'pagination__page--active': p === page }"
      @click="$emit('change', p)"
    >
      {{ p }}
    </button>

    <button
      class="pagination__btn"
      :disabled="page === totalPages"
      @click="$emit('change', page + 1)"
    >
      ›
    </button>
  </div>
</template>

<script>
export default {
  name: "PaginationAffiliationPromotions",

  props: {
    page: Number,
    pageSize: Number,
    total: Number
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },

    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.page - 2);
      const end = Math.min(this.totalPages, this.page + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  gap: 6px;
  margin-top: 20px;
}

.pagination__btn,
.pagination__page {
  border: 1px solid #ddd;
  background: white;
  padding: 6px 10px;
  cursor: pointer;
}

.pagination__page--active {
  background: #ffc944;
  color: white;
}
</style>
